var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3181_1789)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3181_1789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7782 20.0282C17.7153 22.0911 14.9174 23.25 12 23.25C9.08262 23.25 6.28473 22.0911 4.22183 20.0282C2.15893 17.9653 1 15.1674 1 12.25C1 9.33262 2.15893 6.53473 4.22183 4.47183C6.28473 2.40893 9.08262 1.25 12 1.25C14.9174 1.25 17.7153 2.40893 19.7782 4.47183C21.8411 6.53473 23 9.33262 23 12.25C23 15.1674 21.8411 17.9653 19.7782 20.0282Z",
    fill: "#D9D9D9",
    stroke: "#EB8F5C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3181_1789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3181_1789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackIncomplete);
export default __webpack_public_path__ + "static/media/track-incomplete.a760f92d1bbf8eed51139a18a0be7c98.svg";
export { ForwardRef as ReactComponent };